import { useEffect, useState } from 'react';

export const useDiceMarker = (sequence, moving) => {
  const [state, setState] = useState({ sequence: null, phase: 'hidden' });
  useEffect(() => {
    if (!sequence) { setState({ sequence, phase: 'hidden' }); return; }
    if (moving) { setState({ sequence, phase: 'moving' }); return; }
    setState({ sequence, phase: 'landed' });
    const fade = setTimeout(() => setState({ sequence, phase: 'leaving' }), 1200);
    const hide = setTimeout(() => setState({ sequence, phase: 'hidden' }), 1460);
    return () => { clearTimeout(fade); clearTimeout(hide); };
  }, [sequence, moving]);
  if (!sequence) return 'hidden';
  return state.sequence !== sequence ? moving ? 'moving' : 'landed' : state.phase;
};